var map = {
	"./home.png": "2875",
	"./home_h.png": "cb23",
	"./live.png": "5be1",
	"./live_h.png": "5352",
	"./my.png": "b79c",
	"./my_h.png": "3407",
	"./play.png": "3855",
	"./post.png": "c198",
	"./post_h.png": "5b48",
	"./share.png": "65fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "842c";